module.exports = "/static/media/dots_icon.d68d5d90.svg";